
import Vue from "vue";
import { getNotes } from "./../../api";
import { getHeaders } from "./../../helpers";
import { mapState, mapMutations } from "vuex";
import UpdateMultipleItems from "@/components/Tables/components/UpdateMultipleItems";
import TempStarsTableTitle from "@/components/shared/TempStarsTableTitle";

export default Vue.extend({
  name: "Notes",
  components: {
    UpdateMultipleItems,
    TempStarsTableTitle
  },
  data: () => {
    return {
      tab: null,
      search: "",
      notes: {} as any,
      hygienistsHeaders: [] as any,
      locationHeaders: [] as any
    };
  },
  methods: {
    ...mapMutations(["modify"]),
    headers(array) {
      getHeaders(array);
    },
    async getNotes() {
      this.notes = await getNotes();
      this.hygienistsHeaders = getHeaders(this.notes.hygienist);
      this.locationHeaders = getHeaders(this.notes.locations);
    }
  },
  async created() {
    this.getNotes();
  }
});
